<template lang="pug">
  div(id="object-links-list")
    b-card(
        :header="list_header"
        header-tag="h4"
        bg-variant="light"
        )

      template(v-if="show_list")
        component( v-for="(link, index) in links"
                           v-bind:is="item_component"
                           v-bind="link.attributes"
                           :objects="objects"
                           :key="index"
                           :index="index"
                           @delete_click="delete_link"
                           @save="on_save")

      template(v-slot:footer)
        b-button(
            v-if="can_add_link"
            size="sm"
            @click="add_link") Add
</template>

<script>

  import DebugLog from "./DebugLog"

  export default {
    name: 'BaseLinkListStore',
    extends: DebugLog,
    props: {
      linked_id: [Number, String],
      linked_type: String,
      max_links: Number,
      read_only: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        // Logging to console
        log: false,
        // set child component - List Item
        item_component:     undefined,
        // set ReadOnly child component - List Item
        ro_item_component:  undefined,
        list_header:        'Change me in component data',
        objects_getter:     '', //'tours/available_cities_collection',
        get_objects_action: '', //'tours/getAvailableCities',
        get_links_action:   '', //'tours/getCityLinks',
        get_links_payload: {
          id: this.linked_id,
          type: this.linked_type
        },
        delete_link_action: '', //'tours/deleteCityLink',
        // set a scaffold for new_link object
        new_link: {
          id: undefined,
          attributes: {
            id: undefined,
            object_id: undefined,
            linked_id: this.linked_id,
            linked_type: this.linked_type,
          }
        },
        // do not change this
        new_links: [],
        show_always: false,
      }
    },
    computed: {
      // change me on extended component
      stored_links() {
        return []; //this.$store.state.tours.city_links;
      },

      used_component() {
        return this.read_only ? this.ro_item_component : this.item_component ;
      },

      // do not change this
      objects() {
        return this.$store.getters[this.objects_getter]
      },

      links() {
        return this.stored_links.concat(this.new_links)
      },

      show_list(){
        return (this.show_always || this.objects && (this.objects.length > 0))
      },

      can_add_link() {
        let result = (
            (
              (this.max_links == undefined) ||
              ((this.max_links == null)) ||
              (this.links.length < this.max_links)
            ) && !this.read_only
        );
        this.debugMsg('Can i add link? > ', result);
        return result;
      },
    },
    beforeMount() {
      if (this.get_objects_action !== undefined) {
        this.$store.dispatch(this.get_objects_action);

      }
      if (this.get_links_action !== undefined) {
        this.$store.dispatch(this.get_links_action, this.get_links_payload);

      }
    },

    methods: {
      add_link() {
        this.new_links.push(this.new_link);
      },

      delete_link(index) {
        this.debugMsg("delete_link - index", index);
        let link = this.links[index],
          n_index,
          vc = this;

        if (link.id === undefined) {
          n_index = index - this.stored_links.length;
          vc.new_links.splice(n_index, 1);
        } else {
          vc.$store.dispatch(vc.delete_link_action, {id: link.id});
        }
      },

      on_save(data, index) {
        this.debugMsg('on_save - list!', data, index);
        let n_index = index - this.stored_links.length;
        if (n_index >= 0) {
          this.new_links.splice(n_index, 1);
        }

        this.$store.dispatch(this.get_links_action, this.get_links_payload);
      },
    },
  }
</script>